module.exports = __webpack_public_path__ + "img/header.daaac289.png";